<template>
  <div>
    <el-page-header @back="$router.push('./.')" :content="title" />
    <el-form
      :model="employeeFrom"
      ref="employeeFrom"
      label-width="80px"
      :rules="rules"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-card style="min-height: 500px">
            <div slot="header">手机号查询</div>
            <el-form-item label="手机号码" style="width: 75%">
              <el-input
                type="text"
                oninput="value=value.replace(/\D/g,'')"
                placeholder="请输入手机号"
                v-model="employeeFrom.searchPhone"
                maxlength="11"
              >
              </el-input>
              <el-button type="primary" size="small" @click="searchPerson">查询此人</el-button>
            </el-form-item>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card style="min-height: 500px">
            <div slot="header">员工信息</div>
            <div v-show="!searchFlag">
              请输入手机号码查询用户
            </div>
            <div v-if="searchFlag&&employSearchData">
              <el-form-item label="工种" prop="role" style="width: 75%">
                <el-select
                  style="width: 100%"
                  v-model="employeeFrom.role"
                  placeholder="请选择工种"
                >
                  <el-option
                    v-for="(item, index) in workOption"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="姓名" prop="name" style="width: 75%">
                <el-input
                  v-model="employeeFrom.name"
                  maxlength="30"
                  placeholder="请输入员工姓名"
                  readonly
                />
                <el-button style="margin-top: 8px" type="primary" size="small" @click="enterEnterprise"
                >拉入公司</el-button>
              </el-form-item>
            </div>
            <div v-if="searchFlag&&!employSearchData">
              <el-form-item
                label="所属公司"
                style="width: 75%"
              >
                <el-input
                  v-model="employeeFrom.enterpriseName"
                  :rows="6"
                  disabled
                />
              </el-form-item>
              <el-form-item label="姓名" prop="name" style="width: 75%">
                <el-input
                  v-model="employeeFrom.name"
                  :rows="6"
                  maxlength="30"
                  placeholder="请输入员工姓名"
                />
              </el-form-item>
              <el-form-item label="手机号码" prop="phone" style="width: 75%">
                <el-input
                  type="text"
                  oninput="value=value.replace(/\D/g,'')"
                  placeholder="请输入数字"
                  v-model="employeeFrom.phone"
                  maxlength="11"
                  readonly
                >
                </el-input>
              </el-form-item>
              <el-form-item
                label="密码"
                prop="password"
                style="width: 75%"
              >
                <el-input
                  v-model="employeeFrom.password"
                  placeholder="请输入密码"
                />
              </el-form-item>
              <el-col>
                <el-form-item
                  label="工种"
                  prop="role"
                >
                  <el-select
                    v-model="employeeFrom.role"
                    placeholder="请选择工种"
                  >
                    <el-option
                      v-for="(item, index) in workOption"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col> </el-col>
              <el-col :span="12"> </el-col>
              <el-col>
                <el-form-item label="">
                  <el-button type="warning" @click="clearFrom"
                  >清空</el-button
                  >
                  <el-button type="primary" @click="save"
                  >保存个人信息</el-button
                  >
                </el-form-item>
              </el-col>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import { searchByphone,personSearch,postPersonIdEnterEnterprise,personAdd} from '@/api/person.js'
  export default {
    name:'PersonEditor',
    data() {
      return {
        employeeFrom: {
          id: undefined,
          enterpriseName: this.$store.getters.currentEnterprise.name,
          entrId: '',
          name: '',
          password: '',
          sex: '',
          role: '', //角色
          status: '',
          phone: '',
          searchPhone:''
        },
        employSearchData:false,
        workOption: [
          {
            label: '工人',
            value: 'product-executor',
          },
          {
            label: '管理',
            value: 'product-manager',
          },
        ],
        searchFlag:false,
        personList:[],
        rules: {
          name: [
            { required: true, message: '员工名称不能为空', trigger: 'change' }
          ],
          password:[
            { required: true, message: '密码不能为空', trigger: 'change' }
          ],
          role: [
            { required: true, message: '请选择工种', trigger: 'change' }
          ],
          phone: [
            { required: true, message: '手机号不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    computed:{
      title(val){
        return '新增员工'
      }
    },
    mounted() {
      this.personDataGet()
    },
    methods:{
      personDataGet() {
        this.enterpriseId = this.$store.getters.currentEnterprise.id
        let option = {
          pageNum: 1,
          pageSize: 0,
          enterpriseId: this.$store.getters.currentEnterprise.id,
        }
        personSearch(this.enterpriseId, option).then((data) => {
          this.personList = data.data.list
        })
      },
      save() {
        this.$refs.employeeFrom.validate((valid)=>{
          if(valid) {
            this.employeeFrom.entrId = this.$store.getters.currentEnterprise.id
            personAdd(this.employeeFrom)
              .then((data) => {
                this.employeeName = null
              })
              .then(() => {
                this.$router.push('./.')
                this.$message.success('提交成功')
              })
          }
        })

      },
      clearFrom() {
        this.employeeFrom.id=undefined
        this.employeeFrom.entrId=""
        this.employeeFrom.name=""
        this.employeeFrom.password=""
        this.employeeFrom.role=""
        this.employeeFrom.status=""
      },
      searchPerson() {
        let obj=this.personList.find(item=>item.phone==this.employeeFrom.searchPhone)
        if(this.employeeFrom.searchPhone=='') {
          this.$message.error('请输入手机号')
          return;
        }
        if(obj) {
          console.log(obj)

          obj.roleFormat= obj.role == 'product-executor'?'工人':'管理'
          this.$message.error(`该用户已在本公司，${obj.name}，${obj.roleFormat}`)
          return
        }
        let entrId = -1
        searchByphone(this.employeeFrom.searchPhone,entrId).then(data=>{
          this.clearFrom()
          this.employSearchData=data.data?true:false
          this.searchFlag=true
          if(data.data){
            this.employeeFrom.id=data.data.id
            this.employeeFrom.name=data.data.name
          }
          this.employeeFrom.phone=this.employeeFrom.searchPhone
        })
      },
      // 人员拉入公司
      enterEnterprise() {
        if(this.employeeFrom.role==''){
          this.$message.error('请选择工种')
          return
        }
        let form = {
          id: this.employeeFrom.id,
          entrId: this.$store.getters.currentEnterprise.id,
          role: this.employeeFrom.role,
        }
        postPersonIdEnterEnterprise(form).then((r) => {
          this.$message.success(r.message)
          this.$router.push('./.')
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/meta/person/PersonAdd.vue